import * as React from "react";
import { useEffect } from "react";
import "./assets/fonts/inter.css";
import "./assets/fonts/material.css";
import "./assets/fonts/icofont/icofont.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/sass/styles.scss";
import "./i18n";

import { createRoot } from "react-dom/client";
import { ThemeProvider } from "./context/Themes";
import { SidebarProvider } from "./context/Sidebar";
import { LoaderProvider } from "./context/Preloader";
import { TranslatorProvider } from "./context/Translator";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import {
  LoginPage,
  RegisterPage,
  ForgotPasswordPage,
  WelcomePage,
} from "./pages/auth";
import { ErrorPage } from "./pages/others";
import {
  EcommercePage,
  AnalyticsPage,
  CRMPage,
  UserListPage,
  UserProfilePage,
  MyAccountPage,
  ProductListPage,
  ProductViewPage,
  ProductUploadPage,
  InvoiceListPage,
  InvoiceDetailsPage,
  OrderListPage,
  MessagePage,
  NotificationPage,
  BlankPage,
  SwapFarmPPM,
  SettingsPage,
  SwapAppPPM
} from "./pages/main";
import {
  Userlist,
  Bounty_Logs,
  Coin_Purchase,
  Deposit,
  Directs,
  MyAccount,
  ProductList,
  Team,
  UserProfile,
  Buy_Coin,
  Wallet_Log,
  Bounty_Log_Autopool,
  Withdrawalhistroy,
  Withdrawal,
} from "./pages/main";

import ProtectedRoute from "./components/ProtectedRoute";
import AuthRoute from "./components/AuthRoute";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";

// Set the theme once on load
localStorage.setItem("theme", "dark_mode");

const router = createBrowserRouter([
  
  {
    path: "/login",
    element: (
      <AuthRoute>
        <LoginPage />
      </AuthRoute>
    ),
  },
  {
    path: "/register",
    element: (
      <AuthRoute>
        <RegisterPage />
      </AuthRoute>
    ),
  },
  {
    path: "/welcome",
    element: (
      <AuthRoute>
        <WelcomePage />
      </AuthRoute>
    ),
  },
  
  {
    path: "/forgot-password",
    element: (
      <AuthRoute>
        <ForgotPasswordPage />
      </AuthRoute>
    ),
  },

  // Protected routes
  
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <EcommercePage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/user-list",
    element: (
      <ProtectedRoute>
        <UserListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/user-profile",
    element: (
      <ProtectedRoute>
        <UserProfilePage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/my-account",
    element: (
      <ProtectedRoute>
        <MyAccountPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/product-list",
    element: (
      <ProtectedRoute>
        <ProductListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/Directs",
    element: (
      <ProtectedRoute>
        <Directs />
      </ProtectedRoute>
    ),
  },
  {
    path: "/Team",
    element: (
      <ProtectedRoute>
        <Team />
      </ProtectedRoute>
    ),
  },
  {
    path: "/Deposit",
    element: (
      <ProtectedRoute>
        <Deposit />
      </ProtectedRoute>
    ),
  },
  {
    path: "/Coin_Purchase",
    element: (
      <ProtectedRoute>
        <Coin_Purchase />
      </ProtectedRoute>
    ),
  },
  {
    path: "/Bounty_Logs",
    element: (
      <ProtectedRoute>
        <Bounty_Logs />
      </ProtectedRoute>
    ),
  },
  {
    path: "/Buy_Coin",
    element: (
      <ProtectedRoute>
        <Buy_Coin />
      </ProtectedRoute>
    ),
  },
  {
    path: "/Wallet_Log",
    element: (
      <ProtectedRoute>
        <Wallet_Log />
      </ProtectedRoute>
    ),
  },
  {
    path: "/Bounty_Log_Autopool",
    element: (
      <ProtectedRoute>
        <Bounty_Log_Autopool />
      </ProtectedRoute>
    ),
  },
  {
    path: "/withdrawal",
    element: (
      <ProtectedRoute>
        <Withdrawal />
      </ProtectedRoute>
    ),
  },
  {
    path: "/withdrawalhistory",
    element: (
      <ProtectedRoute>
        <Withdrawalhistroy />
      </ProtectedRoute>
    ),
  },
  {
    path: "/swap-farm-ppm",
    element: (
      <ProtectedRoute>
        <SwapFarmPPM />
      </ProtectedRoute>
    ),
  },
  {
    path: "/swap-app-ppm",
    element: (
      <ProtectedRoute>
        <SwapAppPPM />
      </ProtectedRoute>
    ),
  },
  {
    path: "/BlankPage",
    element: (
      <ProtectedRoute>
        <BlankPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "*",
    element: <ErrorPage />, // Error page to display for undefined routes
  },
]);

const App = () => {
  useEffect(() => {



    try {
        
      axios.get('https://api.ipify.org/?format=json')
      .then((acc)=>{
          console.log(acc.data.ip)

          let IP = acc.data && acc.data.ip ? acc.data.ip : '122.177.56.91'
          typeof window !== "undefined" && window.localStorage.setItem('bpipos',IP)
        
      })
      .catch((err)=>{
          console.log(err)
          typeof window !== "undefined" && window.localStorage.setItem('bpipos','122.177.56.91')

      })

  } catch (error) {
    typeof window !== "undefined" && window.localStorage.setItem('bpipos','122.177.56.91')
      console.log(error)
  }

   




  }, []);

  return (
    <ThemeProvider>
      <LoaderProvider>
        <TranslatorProvider>
          <SidebarProvider>
            <ToastContainer />
            <RouterProvider router={router} />
          </SidebarProvider>
        </TranslatorProvider>
      </LoaderProvider>
    </ThemeProvider>
  );
};

createRoot(document.getElementById("root")).render(<App />);




// import * as React from "react";
// import "./assets/fonts/inter.css";
// import "./assets/fonts/material.css";
// import "./assets/fonts/icofont/icofont.css";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "./assets/sass/styles.scss";
// import "./i18n";

// import { createRoot } from "react-dom/client";
// import { ThemeProvider } from "./context/Themes";
// import { SidebarProvider } from "./context/Sidebar";
// import { LoaderProvider } from "./context/Preloader";
// import { TranslatorProvider } from "./context/Translator";
// import { createBrowserRouter, RouterProvider } from "react-router-dom";
// import {
//   LoginPage,
//   RegisterPage,
//   ForgotPasswordPage,
//   WelcomePage,
// } from "./pages/auth";
// import { ErrorPage } from "./pages/others";
// import {
//   EcommercePage,
//   AnalyticsPage,
//   CRMPage,
//   UserListPage,
//   UserProfilePage,
//   MyAccountPage,
//   ProductListPage,
//   ProductViewPage,
//   ProductUploadPage,
//   InvoiceListPage,
//   InvoiceDetailsPage,
//   OrderListPage,
//   MessagePage,
//   NotificationPage,
//   BlankPage,
//   SettingsPage,
// } from "./pages/main";
// import {
//   Userlist,
//   Bounty_Logs,
//   Coin_Purchase,
//   Deposit,
//   Directs,
//   MyAccount,
//   ProductList,
//   Team,
//   UserProfile,
//   Buy_Coin,
//   Wallet_Log,
//   Bounty_Log_Autopool,
//   Withdrawalhistroy,
//   Withdrawal,
// } from "./pages/main";

// import ProtectedRoute from "./components/ProtectedRoute";
// import AuthRoute from "./components/AuthRoute";
// import { ToastContainer, toast } from "react-toastify";

// localStorage.setItem("theme", "dark_mode");

// const router = createBrowserRouter([
//   {
//     path: "/login",
//     element: (
//       <AuthRoute>
//         <LoginPage />
//       </AuthRoute>
//     ),
//   },
//   {
//     path: "/register",
//     element: (
//       <AuthRoute>
//         <RegisterPage />
//       </AuthRoute>
//     ),
//   },
//   {
//     path: "/welcome",
//     element: (
//       <AuthRoute>
//         <WelcomePage />
//       </AuthRoute>
//     ),
//   },
//   {
//     path: "/forgot-password",
//     element: (
//       <AuthRoute>
//         <ForgotPasswordPage />
//       </AuthRoute>
//     ),
//   },

//   // Protected routes
//   {
//     path: "/",
//     element: (
//       <ProtectedRoute>
//         <EcommercePage />
//       </ProtectedRoute>
//     ),
//   },
//   {
//     path: "/user-list",
//     element: (
//       <ProtectedRoute>
//         <UserListPage />
//       </ProtectedRoute>
//     ),
//   },
//   {
//     path: "/user-profile",
//     element: (
//       <ProtectedRoute>
//         <UserProfilePage />
//       </ProtectedRoute>
//     ),
//   },
//   {
//     path: "/my-account",
//     element: (
//       <ProtectedRoute>
//         <MyAccountPage />
//       </ProtectedRoute>
//     ),
//   },
//   {
//     path: "/product-list",
//     element: (
//       <ProtectedRoute>
//         <ProductListPage />
//       </ProtectedRoute>
//     ),
//   },
//   {
//     path: "/Directs",
//     element: (
//       <ProtectedRoute>
//         <Directs />
//       </ProtectedRoute>
//     ),
//   },
//   {
//     path: "/Team",
//     element: (
//       <ProtectedRoute>
//         <Team />
//       </ProtectedRoute>
//     ),
//   },
//   {
//     path: "/Deposit",
//     element: (
//       <ProtectedRoute>
//         <Deposit />
//       </ProtectedRoute>
//     ),
//   },
//   {
//     path: "/Coin_Purchase",
//     element: (
//       <ProtectedRoute>
//         <Coin_Purchase />
//       </ProtectedRoute>
//     ),
//   },
//   {
//     path: "/Bounty_Logs",
//     element: (
//       <ProtectedRoute>
//         <Bounty_Logs />
//       </ProtectedRoute>
//     ),
//   },
//   {
//     path: "/Buy_Coin",
//     element: (
//       <ProtectedRoute>
//         <Buy_Coin />
//       </ProtectedRoute>
//     ),
//   },
//   {
//     path: "/Wallet_Log",
//     element: (
//       <ProtectedRoute>
//         <Wallet_Log />
//       </ProtectedRoute>
//     ),
//   },
//   {
//     path: "/Bounty_Log_Autopool",
//     element: (
//       <ProtectedRoute>
//         <Bounty_Log_Autopool />
//       </ProtectedRoute>
//     ),
//   },
//   {
//     path: "/withdrawal",
//     element: (
//       <ProtectedRoute>
//         <Withdrawal />
//       </ProtectedRoute>
//     ),
//   },
//   {
//     path: "/withdrawalhistory",
//     element: (
//       <ProtectedRoute>
//         <Withdrawalhistroy />
//       </ProtectedRoute>
//     ),
//   },
//   {
//     path: "/BlankPage",
//     element: (
//       <ProtectedRoute>
//         <BlankPage />
//       </ProtectedRoute>
//     ),
//   },

//   {
//     path: "*",
//     element: <ErrorPage />, // Error page to display for undefined routes
//   },
// ]);

// createRoot(document.getElementById("root")).render(
//   <ThemeProvider>
//     <LoaderProvider>
//       <TranslatorProvider>
//         <SidebarProvider>
//           <ToastContainer />
//           <RouterProvider router={router} />
//         </SidebarProvider>
//       </TranslatorProvider>
//     </LoaderProvider>
//   </ThemeProvider>
// );
